function _heroCookiebotGetCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}

function _heroCookiebotSetCookie(name, value, days) {
    let cookieStr = name + "=" + encodeURIComponent(value) + "; path=/";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        cookieStr += "; expires=" + date.toUTCString();
    }
    document.cookie = cookieStr;
}

function _heroCookiebotGetFallbackAttribution() {
    const referrer = document.referrer;
    let resolvedReferrer = 'direct';
    if (referrer) {
        try {
            const referrerHost = new URL(referrer).hostname;
            if (referrerHost !== window.location.hostname && !referrerHost.includes('hero-software.')) {
                resolvedReferrer = referrer;
            }
        } catch (e) { /* ungültige URL → direct */ }
    }
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'utm_adgroup'];
    const utms = {};
    utmKeys.forEach(function (k) { const v = params.get(k); if (v) utms[k] = v; });
    return {
        referrer: resolvedReferrer,
        landingpage: window.location.origin + window.location.pathname,
        utms: Object.keys(utms).length > 0 ? JSON.stringify(utms) : null
    };
}

window.addEventListener('CookiebotOnAccept', function () {
    // Analytics-Consent: Tracking-Cookies auf 365 Tage verlängern
    if (Cookiebot.consent.statistics) {
        const attr = window._heroAttribution || _heroCookiebotGetFallbackAttribution();
        if (attr.referrer && attr.referrer !== 'direct') {
            // Non-direkter Seitenaufruf: Attribution auf aktuelle Quelle aktualisieren.
            // Wichtig wenn Consent re-granted wird, nachdem persistente Cookies eine neue
            // non-direkte Quelle blockiert hatten (z.B. LinkedIn → Consent entzogen → Google → Consent erneut).
            _heroCookiebotSetCookie('_hero_tp_referrer', attr.referrer, 365);
            _heroCookiebotSetCookie('_hero_tp_landingpage', attr.landingpage, 365);
            if (attr.utms !== null) {
                _heroCookiebotSetCookie('_hero_tp_utms', attr.utms, 365);
            } else {
                _heroCookiebotSetCookie('_hero_tp_utms', '', 365);
            }
        } else {
            // Direkter Aufruf oder kein Attribution-Objekt: bestehende Werte nur verlängern
            ['_hero_tp_referrer', '_hero_tp_landingpage', '_hero_tp_utms'].forEach(function (name) {
                const value = _heroCookiebotGetCookie(name);
                if (value !== null) _heroCookiebotSetCookie(name, value, 365);
            });
        }
        const prevUrl = _heroCookiebotGetCookie('_hero_tp_previous_url');
        if (prevUrl !== null) _heroCookiebotSetCookie('_hero_tp_previous_url', prevUrl, 365);
        _heroCookiebotSetCookie('_hero_tp_persistent', '1', 365);
    }

    // Marketing-Consent: UTM-Parameter aus sessionStorage wiederherstellen
    if (Cookiebot.consent.marketing) {
        (function (opts) {
            var current = {
                    state: document.location.href,
                    query: document.location.search.substring(1),
                    time: new Date().getTime()
                },
                storage = {
                    area: window.sessionStorage,
                    key: 'last_utm_query'
                },
                restored,
                updated = {};

            if (/(^|&)utm_/.test(current.query)) {
                storage.area[storage.key] = JSON.stringify({ time: current.time, query: current.query });
            } else if (restored = JSON.parse(storage.area[storage.key] || '""')) {
                if (current.time - restored.time <= opts.expireDays * 864E5) {
                    updated.state = document.createElement('a');
                    updated.state.href = current.state;
                    updated.state.search += (updated.state.search ? '&' : '') + restored.query + '&restored=' + restored.time;
                    // history.replaceState('', {}, updated.state);
                }
            }
        })({ expireDays: 30 });
    }
}, false);

if(window.location.pathname.includes("signup-ios")) {
    Cookiebot.consented = true;
}
